import React from 'react';

interface ExtractorVersionTagProps {
  current: string;
  previous?: string;
}

const basicUrl = 'https://github.com/import-io/robot-library';

const ExtractorVersionTag = ({ current, previous }: ExtractorVersionTagProps): JSX.Element | null => {
  if (!current) {
    return null;
  }

  const url = previous ? `${basicUrl}/compare/${previous}..${current}` : `${basicUrl}/tree/${current}`;
  return (
    <a href={url} className="wb-textDecoration-underline" target="_blank">
      {current}
    </a>
  );
};
export default ExtractorVersionTag;
